export const common = {
  // Navigation
  'nav.home': 'Home',
  'nav.spreadsheet': 'CSSBuy Spreadsheet',
  'nav.products': 'Products',
  'nav.categories': 'Categories',
  'nav.guides': 'Guides',
  'nav.review': 'Review',
  'nav.shipping': 'Shipping',
  'nav.safety': 'Safety',
  'nav.language': 'Language',
  'nav.visitMain': 'Visit Main Site',

  // Hero
  'hero.eyebrow': 'CSSBuy Spreadsheet 2026',
  'hero.title': 'CSSBuy Spreadsheet: Find, Compare and Organize CSSBuy Products in One Place',
  'hero.subtitle': 'Find spreadsheets, products, categories and CSSBuy guides all in one place. Compare options, check QC, warehouse and shipping information and discover useful resources for researching before you buy.',
  'hero.ctaPrimary': 'Explore CSSBuy Spreadsheet',
  'hero.ctaSecondary': 'View Beginner Guide',
  'hero.ctaMain': 'Visit Main Site',
  'hero.trust': 'Independent resource • Practical guides • Comparisons • Portuguese, English and Deutsch',

  // Search
  'search.title': 'Find what you are looking for quickly',
  'search.placeholder': 'Search CSSBuy Spreadsheet, sneakers, hoodies, QC, shipping...',
  'search.filters': 'Spreadsheet / Products / QC / Shipping / Guides / Reviews / Coupons',

  // Quick Links
  'quick.spreadsheet': 'Spreadsheet',
  'quick.products': 'Products',
  'quick.qc': 'QC',
  'quick.shipping': 'Shipping',
  'quick.guides': 'Guides',
  'quick.reviews': 'Reviews',
  'quick.coupons': 'Coupons',

  // Categories
  'categories.title': 'Explore CSSBuy Spreadsheet by category',
  'categories.cta': 'View all categories',

  // Value Proposition
  'value.title': 'Everything you need to research better',
  'value.find': 'Find faster',
  'value.findDesc': 'Organized resources to make research easier.',
  'value.compare': 'Compare options',
  'value.compareDesc': 'Tables and guides to compare information.',
  'value.process': 'Understand the process',
  'value.processDesc': 'Content about products, QC, warehouse and shipping.',
  'value.safety': 'More safety',
  'value.safetyDesc': 'Learn to identify suspicious links and outdated information.',
  'value.lang': 'Multilingual',
  'value.langDesc': 'Portuguese, English and Deutsch.',

  // Featured
  'featured.title': 'CSSBuy Spreadsheet: Featured Resources',
  'featured.cta': 'View resource',

  // Review
  'review.title': 'CSSBuy Review: What you need to know',
  'review.text': 'Before using any international shopping service, it is important to understand products, warehouse, QC, shipping, payments and risks. Our CSSBuy Review brings together the key points to make your research easier.',
  'review.cta': 'Read CSSBuy Review',

  // Shipping
  'shipping.title': 'CSSBuy Shipping Cost: Understand shipping costs',
  'shipping.text': 'Shipping costs may vary depending on weight, volume, destination, method and current conditions. Always confirm available rates before completing a purchase.',
  'shipping.cta': 'View CSSBuy Shipping Cost',

  // Safety
  'safety.title': 'CSSBuy Safety: Research more safely',
  'safety.text': 'Links can become outdated, prices can change and fake pages may try to imitate legitimate services. Learn to verify URLs, protect your account and avoid suspicious links.',
  'safety.cta': 'Visit Safety Center',

  // FAQ
  'faq.title': 'Frequently Asked Questions — CSSBuy Spreadsheet',
  'faq.q1': 'What is CSSBuy Spreadsheet?',
  'faq.a1': 'CSSBuy Spreadsheet is an organized resource that brings together links, products, categories and useful information for those using the CSSBuy platform. It makes it easier to research and compare products before buying.',
  'faq.q2': 'How to use a CSSBuy Spreadsheet?',
  'faq.a2': 'Open the spreadsheet, browse the product categories, check the links and QC information, compare prices and read the shipping guides before making a purchase.',
  'faq.q3': 'Where to find CSSBuy links?',
  'faq.a3': 'CSSBuy links can be found in organized spreadsheets, community forums, specialized guides and independent resources like this site.',
  'faq.q4': 'What does W2C mean?',
  'faq.a4': 'W2C means "Where To Cop" — a common expression in shopping communities that indicates where to find a specific product.',
  'faq.q5': 'How to verify products?',
  'faq.a5': 'Check QC photos, read detailed descriptions, compare with official images and consult community reviews before buying.',
  'faq.q6': 'Is CSSBuy legit?',
  'faq.a6': 'CSSBuy is a known shopping agent platform. Like any international service, it is important to research, verify official URLs and understand the risks before using.',

  // Final CTA
  'finalCta.title': 'Ready to explore CSSBuy Spreadsheet?',
  'finalCta.text': 'Start with the most popular resources, compare categories and consult our guides before continuing your research.',
  'finalCta.explore': 'Explore CSSBuy Spreadsheet',
  'finalCta.visit': 'Visit Main Site',
  'finalCta.disclaimer': 'This is an independent resource and is not affiliated with, sponsored by or officially endorsed by CSSBuy.',

  // Footer
  'footer.spreadsheet': 'CSSBuy Spreadsheet',
  'footer.guides': 'Guides',
  'footer.categories': 'Categories',
  'footer.comparisons': 'Comparisons',
  'footer.safety': 'Safety',
  'footer.about': 'About',
  'footer.legal': 'Legal',
  'footer.languages': 'Languages',
  'footer.disclaimer': 'CSSBuyBR.TOP is an independent resource and is not affiliated with, sponsored by or officially endorsed by CSSBuy.',
  'footer.privacy': 'Privacy Policy',
  'footer.terms': 'Terms of Use',
  'footer.disclaimerLink': 'Disclaimer',
  'footer.contact': 'Contact',

  // Articles
  'articles.title': 'CSSBuy Spreadsheet Articles and Guides',
  'articles.readMore': 'Read article',
  'articles.readTime': 'min read',

  // Category Buttons
  'cat.shoes': 'Shoes',
  'cat.hoodies': 'Hoodies/Sweaters',
  'cat.tshirts': 'T-Shirts',
  'cat.jackets': 'Jackets',
  'cat.pants': 'Pants/Shorts',
  'cat.headwear': 'Headwear',
  'cat.sets': 'Sets',
  'cat.underwear': 'Underwear/Underpants',
  'cat.jersey': 'Jersey',
  'cat.accessories': 'Accessories',
  'cat.bags': 'Bags',
  'cat.belts': 'Belts',
  'cat.perfumes': 'Perfumes',
  'cat.other': 'Other Stuff',

  // Buttons
  'btn.cssbuySpreadsheet': 'CSSBuy Spreadsheet',
  'btn.buyItNow': 'Buy It Now',
  'btn.explore': 'Explore',
  'btn.readMore': 'Read more',
  'btn.backToHome': 'Back to home',

  // Products
  'products.title': 'CSSBuy Spreadsheet Products',
  'products.subtitle': 'Find the best CSSBuy Spreadsheet products across all categories. Click any item to purchase on the main site.',
  'products.buyNow': 'Buy Now',
  'products.allCategories': 'All Categories',
  'products.count': 'products',
  'products.noProducts': 'No products found in this category.',
  'products.featuredTitle': 'Featured Products',
  'products.viewAll': 'View all products',

  // Content Page
  'content.relatedPages': 'Related Pages',
  'article.disclaimerExtra': 'This article is for informational purposes only. Always verify current information directly with official sources before making any purchasing decisions.',
  'content.tableOfContents': 'Table of Contents',
  'content.continueShopping': 'Continue Shopping',
  'content.visitMain': 'Visit Main Site',
  'content.relatedResources': 'Related Resources',
  'content.backToHome': 'Back to Homepage',
  'content.spreadsheetHub': 'CSSBuy Spreadsheet Hub',
  'content.shippingCostGuide': 'Shipping Cost Guide',
  'content.browseCategories': 'Browse Categories',
  'content.disclaimer': 'Disclaimer',
  'content.published': 'Published',
  'content.updated': 'Updated',
  'content.by': 'By',

  // Hero Card
  'hero.cardTitle': 'CSSBuy Spreadsheet',
  'hero.organizedResources': 'Organized Product Resources',
  'hero.categoriesCount': '14 categories',
  'hero.viewAll': 'View all',

  // Articles
  'articles.viewAll': 'View all',

  // Home CTA
  'home.cta.description': 'Explore the full CSSBuy product catalog and find the best items available right now.',

  // Not Found
  'notFound.title': 'Page Not Found',
  'notFound.path': 'Path',
  'notFound.description': 'This page was not found. Go back to the homepage or explore our resources.',

  // Footer
  'footer.warehouse': 'CSSBuy Warehouse',
  'footer.coupon': 'CSSBuy Coupon',
  'footer.legit': 'Is CSSBuy Legit?',
  'footer.faq': 'FAQ',

  // Contact
  'contact.title': 'Contact',
  'contact.contactUs': 'Contact Us',
  'contact.messageSent': 'Message Sent',
  'contact.thankYou': 'Thank you for reaching out. We will get back to you soon.',
  'contact.sendAnother': 'Send another message',
  'contact.sendMessage': 'Send Message',
  'contact.name': 'Name',
  'contact.email': 'Email',
  'contact.subject': 'Subject',
  'contact.message': 'Message',
  'contact.maxChars': 'Maximum 500 characters',
  'contact.description': 'Have questions, feedback, or suggestions? Reach out and we will respond as soon as possible.',

  // FAQ
  'faq.stillQuestions': 'Still have questions?',
  'faq.exploreMore': 'Explore more resources on the main site or contact us through the contact page.',
  'faq.contactBtn': 'Contact Us',
  'faq.description': 'Find answers to common questions about CSSBuy, spreadsheets, products, shipping, and safety.',

  // Products
  'products.eyebrow': 'CSSBuy Spreadsheet 2026',

  // About
  'about.title': 'About CSSBuyBR.TOP',
  'about.whatWeDo': 'What We Do',
  'about.independence': 'Our Independence',
  'about.contentPolicy': 'Content Policy',
  'about.languages': 'Languages',
  'about.disclaimer': 'Disclaimer',
  'about.primary': 'Primary language',
  'about.international': 'International',
  'about.german': 'German',

  // Privacy
  'privacy.info': 'Information We Collect',
  'privacy.use': 'How We Use Information',
  'privacy.cookies': 'Cookies',
  'privacy.thirdParty': 'Third-Party Links',
  'privacy.security': 'Data Security',
  'privacy.changes': 'Changes to This Policy',
  'privacy.contact': 'Contact',

  // Terms
  'terms.acceptance': 'Acceptance of Terms',
  'terms.independent': 'Independent Resource',
  'terms.accuracy': 'Content Accuracy',
  'terms.noGuarantees': 'No Guarantees',
  'terms.external': 'External Links',
  'terms.ip': 'Intellectual Property',
  'terms.liability': 'Limitation of Liability',
  'terms.changes': 'Changes to Terms',
  'terms.governing': 'Governing Law',

  // Disclaimer
  'disclaimer.independent': 'Independent Resource',
  'disclaimer.noAffiliation': 'No Official Affiliation',
  'disclaimer.accuracy': 'Information Accuracy',
  'disclaimer.noAdvice': 'No Professional Advice',
  'disclaimer.external': 'External Links and Risks',
  'disclaimer.responsibility': 'User Responsibility',
  'disclaimer.liability': 'Limitation of Liability',
  'disclaimer.contact': 'Contact',
};

export default common;